import { useState, useEffect } from 'react';
import { useAuthCliente } from '../context/AuthClienteContext';
import { collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';

export function useAnnouncements(options = {}) {
  const { currentUser } = useAuthCliente();
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser?.companyId) {
      setLoading(false);
      return;
    }

    const ref = collection(db, 'companies', currentUser.companyId, 'announcements');
    let q = query(ref, orderBy('createdAt', 'desc'));

    if (options.limit) {
      q = query(ref, orderBy('createdAt', 'desc'), limit(options.limit));
    }

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setAnnouncements(data);
      setLoading(false);
    }, (error) => {
      console.error("Error fetching announcements:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [currentUser?.companyId, options.limit]);

  return { announcements, loading };
}